import {Component, isDevMode, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../auth.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {FullChild} from "../../interfaces/FullChild";
import firebase from "firebase/compat";
import {Centre} from "../../interfaces/Centres";
import {environment} from "../../../environments/environment";
import {UserRole} from "../../components/rename/add-user-role/add-user-role.component";

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
    env = isDevMode() ? environment.testMode : environment.productionMode

    admissions: UserRole[] = (localStorage.getItem('permissions') != null) ? JSON.parse(localStorage.getItem('permissions')!) as UserRole[] : [
        {
            functionName: "Child Admission",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Child Prescreening",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Counselling",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Education",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Meal Mate",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Unit Sponsorship",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "General Donation",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "CMS",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Child Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Counseling Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Education Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Donation Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Weekly Report",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Centres",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Employees",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Hospital",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Unit",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Types",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Donor",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Event",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Audit Logs",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        },
        {
            functionName: "Dashboard",
            all: false,
            add: false,
            edit: false,
            archive: false,
            view: false,
            excel: false,
            showMenu: false
        }
    ];

    dashboardPermission = this.admissions.filter((x) => x.functionName == 'Dashboard')
    counsellingPermission = this.admissions.filter((x) => x.functionName == 'Counselling')
    educationPermission = this.admissions.filter((x) => x.functionName == 'Education')
    childAdmissionPermission = this.admissions.filter((x) => x.functionName == 'Child Admission')
    donationReport = this.admissions.filter((x) => x.functionName == 'Donation Report')
    childReport = this.admissions.filter((x) => x.functionName == 'Child Report')
    weeklyReport = this.admissions.filter((x) => x.functionName == 'Weekly Report')
    mealMate = this.admissions.filter((x) => x.functionName == 'Meal Mate')
    unitSponsership = this.admissions.filter((x) => x.functionName == 'Unit Sponsorship')
    CMS = this.admissions.filter((x) => x.functionName == 'CMS')
    centres = this.admissions.filter((x) => x.functionName == 'Centres')
    Employees = this.admissions.filter((x) => x.functionName == 'Employees')
    Hospital = this.admissions.filter((x) => x.functionName == 'Hospital')
    Unit = this.admissions.filter((x) => x.functionName == 'Unit')
    Types = this.admissions.filter((x) => x.functionName == 'Types')
    Donor = this.admissions.filter((x) => x.functionName == 'Donor')
    Events = this.admissions.filter((x) => x.functionName == 'Event')
    AuditLogs = this.admissions.filter((x) => x.functionName == 'Audit Logs')
    roleAs: string
    userEmail: string = ''
    panelOpenState = true
    isDepartmentHead: boolean = false
    constructor(private router: Router,
                private mDatabase: AngularFireDatabase,
                private mFirestore: AngularFirestore,
                private mAuth: AuthService) {
        console.log(this.admissions)
        this.roleAs = mAuth.getRole()
        this.userEmail = localStorage.getItem('userEmail') || ''
        this.isDepartmentHead = JSON.parse(localStorage.getItem('userData') || '{}').isDepartmentHead === true
        console.log('Role as', this.roleAs)
        // this.mDatabase.list('users').snapshotChanges().subscribe(res=>{
        //  res.forEach(it=>{
        //    console.log('x',it.payload.val())
        //    console.log('y',it.payload.key)
        //  this.mDatabase.object(`users/${it.payload.key}`).update({'uid':it.payload.key})
        //  })
        // })

    }

    ngOnInit(): void {
        // this.addExpiredChildrens()
        // this.moveChildData()
        // this.getWrongGenders()
        // this.backUpALChild()
        // this.setcurrentUnitToSelectUnit()
//this.router.navigateByUrl('dashboard')
//     this.setBulkAge()
//    this.RenameHospitals()
//     this.changeCenterName()
this.setSponsorshipStatus()

        // this.setUnitsBulk(newAlloted)
        //this.setisAllotedToFalseForAll()

        // * For setting status by isAlloted Value
        //   this.setStatus()
      // this.changeExpiredStatus()
    }






    setSponsorshipStatus() {
alert('set sponsorship status')
        this.mFirestore.collection<FullChild>(this.env.child,ref => ref.where('sponsored','==',undefined)).get()

            .subscribe(child => {
                child.docs.forEach(it=>{
                    console.log('TOTAL UNSPONSORED CHILDREN',child.docs.length)
                    this.mFirestore.collection(this.env.child).doc(it.id).update({sponsored: false}).then(res => {
                        console.log('added sponsored status to '+it.id)
                })
            })
        })
    }







}
